import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { siteConfig } from '@/constants/site'

const toAbsoluteUrl = (path: string): string => {
    try {
        return new URL(path, `${siteConfig.url}/`).toString()
    } catch {
        return path
    }
}

export const Seo: FC<SeoProps> = ({
    title,
    description = siteConfig.description,
    ogImage = siteConfig.ogImage
}): ReactNode => {
    const pageTitle = title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const image = ogImage ? toAbsoluteUrl(ogImage) : undefined

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <meta name='keywords' content={siteConfig.keywords.join(', ')} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content='website' />
            <meta property='og:url' content={siteConfig.url} />
            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:locale' content={siteConfig.locale} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />

            {image && <meta property='og:image' content={image} />}
            {image && <meta name='twitter:image' content={image} />}
        </Head>
    )
}
